// Generated by ReScript, PLEASE EDIT WITH CARE

import * as GridTsx from "./Grid.tsx";

let make = GridTsx.Grid;

export {
  make,
}
/* make Not a pure module */
